import React from "react";
import {twMerge} from "tailwind-merge";

export function Overlay(props: { fullScreen?: boolean, className?: string, children: React.ReactNode, zIndex?: number, onClick?: (e: unknown) => void }) {
    return (<div
        className={twMerge(
            "fixed top-0 left-0 w-full h-full flex items-center justify-center",
            props.zIndex ? `z-${props.zIndex}` : "z-50",
            props.fullScreen && "bg-gray-900 dark:bg-gray-900 bg-opacity-50 dark:bg-opacity-50",
            props.className)}
        onClick={() => {
            if (props.onClick) {
                props.onClick(undefined)
            }
        }}
    >
        {props.children}
    </div>);
}